<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";
import {ref} from "vue";
import {useEvaluationSkillCandidateStore} from "@/stores/Evaluation/EvaluationSkillCandidate";
import useTools from "@/use/Tools";
import axios from "axios";
import {useEvaluationInterviewStore} from "@/stores/Evaluation/EvaluationInterview";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$route, $refs} = useTools();

        const notes = ref(null);
        const evaluationSkillCandidateStore = useEvaluationSkillCandidateStore();
        const evaluationInterviewStore = useEvaluationInterviewStore();

        function tolerate() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put(`/evaluationSkillCandidates/tolerate/${$route.params.id}`, notes.value, {
                    headers: {
                        'Content-Type': 'text/plain'
                    }
                }).then(response => {
                    evaluationSkillCandidateStore.updateEvaluationSkillCandidate(response.data);
                    evaluationInterviewStore.setRefresh();
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            getBack,
            notes,
            tolerate,
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="600"
        >
            <v-card>
                <w-toolbar color="purple" :title="$t('evaluation.tolerate')"/>
                <v-card-text>
                    <v-form lazy-validation ref="form">
                        <v-container fluid>
                            <v-row dense>
                                <v-col cols="12">
                                    <w-label :label="$t('common.comment')" required/>
                                    <w-simple-text-area
                                        v-model="notes"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn
                        color="purple"
                        icon="mdi-handshake"
                        :text="$t('evaluation.tolerate')"
                        :loading="loading"
                        @press="tolerate"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>